import { useQuery } from "@tanstack/react-query";
import { AnalyticsService } from "@/services/analytics.service";
import { useAuthStore } from "@/stores/auth-store";
import { adsHttpClient } from "@/utils/ads.http";

const analyticsService = new AnalyticsService(adsHttpClient);

async function fetchAnalyticsDashboardEmbedInfo() {
  return analyticsService.getAnalyticsEmbedInfo();
}

export function useAnalyticsDashboardEmbedInfo() {
  const realm = useAuthStore((state) => state.realm);
  const email = useAuthStore((state) => state.user?.email);

  return useQuery({
    queryKey: ["analytics-dashboard-embed-info", realm, email],
    queryFn: fetchAnalyticsDashboardEmbedInfo,
    enabled: Boolean(realm && email),
    refetchOnMount: true,
    staleTime: 1000 * 60 * 500,
    refetchInterval: 1000 * 60 * 500,
  });
}
